import React, { Component } from 'react'
import { Modal } from "react-bootstrap";
import { Row, Col, Card, Button, Container, Form, Spinner, Table } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";


const ADD_OR_DELETE_LEADS = gql`
        mutation($params:AddOrDeleteLeads) {
            addOrDeleteLeads(params:$params)
        }
    `;


class LeadAssign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch: "",
            branchError: "",
            assignedTo: "",
            assignedToError: "",
            checkBoxError: "",
            getLeadsData: [],
            selectedOptionId: "1",
            search: "",
            currentPageStartCount: 0,
            currentPageEndCount: 10,
            loading: 0,
            selectAll: false,
            submitted: false,
            selectLeadData: [],
            employeesData: [],
            loadingSpinner: 0,
            currentStep: 1,
            dataClear: 1,
            submitError: "",
            type: "1",
            unassignedOrAssignedLeads: [],
            deleteCheckboxChecked: false,
            noDateError: "",
            submitMessage: "",
            submitMessageColor: "",
        };
    }

    handleDeleteCheckboxChange = () => {
        this.setState((prevState) => ({
            deleteCheckboxChecked: !prevState.deleteCheckboxChecked,
            type: prevState.deleteCheckboxChecked ? "1" : "3",
            assignedTo: "",
            assignedToError: "",
            submitError: "",
        }));
    };


    handleInputRadioChange = (val) => {

        if (this.state.getLeadsData.length > 0) {

            console.log("vvvv", val, this.state.getLeadsData[0]);

            if (val == "1") {
                this.setState({ unassignedOrAssignedLeads: this.state.getLeadsData[0].unAssigned_Leads, selectedOptionId: val, type: val, assignedTo: "", assignedToError: "", deleteCheckboxChecked: false, selectAll: false, search: "", submitError: "", selectLeadData: [] })
            } else {
                this.setState({ unassignedOrAssignedLeads: this.state.getLeadsData[0].assigned_Leads, selectedOptionId: val, type: val, assignedTo: "", assignedToError: "", deleteCheckboxChecked: false, selectAll: false, search: "", submitError: "", selectLeadData: [] })
            }
        } else {

            this.setState({ unassignedOrAssignedLeads: [], assignedTo: "", assignedToError: "", })
        }
    }


    handleBranchChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (name == "branch") {
            this.setState({
                branch: value,
                branchError: "",
                getLeadsData: [],
                assignedTo: "",
                assignedToError: "",
                selectAll: false,
                deleteCheckboxChecked: false,
                submitError: "",
                selectedOptionId: "1",
                type: "1",
                unassignedOrAssignedLeads: [],
                search: "",
                noDateError:""
            })

        }
    }

    searchFilter = (e) => {
        let value = e.target.value
        console.log("elllllll", value);
        this.setState({ search: value, currentPageStartCount: 0, currentPageEndCount: 10 })
    }

    pageChange = (pageNumber) => {
        console.log("pageNumber", pageNumber);
        this.setState({
            currentPageStartCount: (+pageNumber - 1) * 10,
            currentPageEndCount: +pageNumber * 10
        })
    }

    handleGetLeads = async () => {

        if (this.state.branch == "") {
            this.setState({ branchError: "Please select Branch" })
            return ""
        }

        this.setState({ loading: 1 })


        const result = await this.props.client.query({
            query: gql`
              query($institute_id:Int,$branch_id:Int){
                getUnassignedAndAssignedLeads(institute_id:$institute_id,branch_id:$branch_id){
                    unAssigned_Leads {
                        employee_id
                        employee_name
                        lead_name
                        lead_mobile
                        father_name
                        father_contact_no
                        lead_id
                    }
                    assigned_Leads {
                        employee_id
                        employee_name
                        lead_name
                        lead_mobile
                        father_name
                        father_contact_no
                        lead_id
                      }
                  
                    }
                }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getUnassignedAndAssignedLeads.length > 0) {

            console.log("dataaaaaaaaaaaaa", result.data.getUnassignedAndAssignedLeads);
            let data = result.data.getUnassignedAndAssignedLeads

            this.setState({ getLeadsData: data, loading: 0, submitted: true, unassignedOrAssignedLeads: data[0].unAssigned_Leads })

        } else {
            this.setState({ loading: 0, noDateError: "No Data Available", unassignedOrAssignedLeads: [], getLeadsData: [] })
        }



        const employeeData = await this.props.client.query({
            query: gql`
              query($institute_id:Int,$branch_id:Int){
                getLeadManagementEmployees(institute_id:$institute_id,branch_id:$branch_id){

                    employee_id
                    assigned_status
                    employee_name
                    emp_mobile                
 
                    }
                }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch),
            },
            fetchPolicy: 'network-only'
        })

        if (employeeData.data.getLeadManagementEmployees.length > 0) {

            let data = employeeData.data.getLeadManagementEmployees

            this.setState({ employeesData: data })

        }

    }

    assignedToHandle = (e) => {
        let name = e.target.name
        let value = e.target.value
        console.log("value", value)
        if (name == "assigned") {
            this.setState({
                assignedTo: value,
                assignedToError: "",
            })

        }
    }

    handleSubmit = () => {

        if (this.state.type == "3") {

            if (this.state.selectLeadData.length == 0) {
                this.setState({ submitError: "Please select at least one lead.", loadingSpinner: 0 });
                return;
            }

            let array = [];
            let employeeArray = [];

            this.state.selectLeadData.map((item) => {
                array.push({ lead_id: item.lead_id });
                employeeArray.push({ employee_id: item.employee_id });
            });

            const params = {
                type: parseInt(this.state.type),
                assigned_emp_id: this.state.type == "3" ? parseInt(employeeArray) : parseInt(this.state.assignedTo),
                inserted_by: parseInt(Cookies.get("id")),
                lead_detatils: array
            };

            this.setState({
                loadingSpinner: 1
            });

            this.addOrDeleteLeads(params).catch((error) => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError: error.graphQLErrors.map((x) => x.message),
                    loadingSpinner: 0
                });
                console.error("ERR =>", error.graphQLErrors.map((x) => x.message));
            });
        } else {

            if (this.state.selectLeadData.length == 0) {
                this.setState({ submitError: "Please select at least one lead.", loadingSpinner: 0 });
                return;
            }

            if (this.state.assignedTo == "") {
                this.setState({ assignedToError: "Please Select" });
                return "";
            }

            let array = [];

            this.state.selectLeadData.map((item) => {
                array.push({ lead_id: item.lead_id });
            });

            const params = {
                type: parseInt(this.state.type),
                assigned_emp_id: parseInt(this.state.assignedTo),
                inserted_by: parseInt(Cookies.get("id")),
                lead_detatils: array
            };

            console.log("params", params);
            this.setState({
                loadingSpinner: 1
            });

            this.addOrDeleteLeads(params).catch((error) => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError: error.graphQLErrors.map((x) => x.message),
                    loadingSpinner: 0
                });
                console.error("ERR =>", error.graphQLErrors.map((x) => x.message));
            });
        }
    };


    addOrDeleteLeads = async (
        params) => {
        await this.props.addOrDeleteLeads({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addOrDeleteLeads) {

                    let successMessage = "";
                    let messageColor = "";

                    if (params.type == 1) {
                        successMessage = "Leads Assign Successfully";
                        messageColor = "successColorGreen"
                    } else if (params.type == 2) {
                        successMessage = "Leads Update Successfully";
                        messageColor = "successColorGreen"
                    } else if (params.type == 3) {
                        successMessage = "Leads Delete Successfully";
                        messageColor = "deleteColorRed"
                    }

                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                        submitMessage: successMessage,
                        submitMessageColor: messageColor
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }

        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };


    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                branch: "",
                branchError: "",
                assignedTo: "",
                assignedToError: "",
                getLeadsData: [],
                selectedOptionId: "1",
                search: "",
                currentPageStartCount: 0,
                currentPageEndCount: 10,
                loading: 0,
                selectAll: false,
                submitted: false,
                selectLeadData: [],
                employeesData: [],
                loadingSpinner: 0,
                currentStep: 1,
                dataClear: 1,
                submitError: "",
                type: "1",
                unassignedOrAssignedLeads: [],
                deleteCheckboxChecked: false,
                noDateError: "",

            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }



    handleSelectAllChange = () => {
        const { unassignedOrAssignedLeads, selectAll } = this.state;
        const updatedLeads = unassignedOrAssignedLeads.map(item => ({
            ...item,
            selected: !selectAll,
        }));

        const updatedSelectLeadData = updatedLeads.filter((lead) => lead.selected);


        this.setState({
            selectAll: !selectAll,
            unassignedOrAssignedLeads: updatedLeads,
            selectLeadData: updatedSelectLeadData,
            submitError: ""
        });
    };

    handleCheckboxChange = (item) => {
        const { unassignedOrAssignedLeads } = this.state;

        const updatedLeads = unassignedOrAssignedLeads.map((lead) => ({
            ...lead,
            selected: lead === item ? !lead.selected : lead.selected,
        }));

        const updatedSelectLeadData = updatedLeads.filter((lead) => lead.selected);
        const allSelected = updatedLeads.every((lead) => lead.selected);

        this.setState({
            unassignedOrAssignedLeads: updatedLeads,
            selectLeadData: updatedSelectLeadData,
            selectAll: allSelected,
            submitError: "",
        });
    };



    render() {

        console.log("bade", this.state)

        let filterStudentData = this.state.unassignedOrAssignedLeads;

        if (this.state.search != "") {
            filterStudentData = this.state.unassignedOrAssignedLeads.filter((item) => item.lead_mobile.includes(this.state.search) || item.lead_name.toLowerCase().includes(this.state.search.toLocaleLowerCase()))
        }

        let startNumber = 0
        let endNumber = filterStudentData.length;


        let pages = Math.ceil(endNumber / 10);

        let pagewiseFilterData = filterStudentData.filter((item, index) => index >= this.state.currentPageStartCount && index < this.state.currentPageEndCount);

        console.log("pages", startNumber, endNumber, pages);


        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Lead Assigning</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    <Row className="mt-2">
                        <Col sm={12}>
                            <Form>
                                <Form.Row>
                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranchName">
                                        <Form.Label className="font-weight-bold">Select Branch</Form.Label>
                                        <Form.Control as="select" name="branch" onChange={this.handleBranchChange} value={this.state.branch}>
                                            <option value="">--Select Branch--</option>
                                            {this.props.globals.globalBranches.map(branchData => (
                                                <option value={branchData.id}>{branchData.branch_name}</option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger">
                                            {this.state.branchError}
                                        </Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranch">
                                        <Button className="btn btn-success submit_btn" onClick={this.handleGetLeads}>
                                            Get Leads</Button>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </Col>
                    </Row>
                    {
                        this.state.getLeadsData.length > 0 ?
                            (
                                <>
                                    <Row>
                                        <Col sm={6}>
                                            <div className='mt-3'>
                                                <Form.Check type="radio" name="radioOption" id="1" label="Un Assign Leads" className="mr-3  RadioButtons h6" onClick={() => { this.handleInputRadioChange("1") }} checked={this.state.selectedOptionId == "1"} style={{ cursor: "pointer" }} />
                                                <Form.Check type="radio" name="radioOption" id="2" label="Assign Leads" className='RadioButtons2 h6' onClick={() => { this.handleInputRadioChange("2") }} style={{ cursor: "pointer" }} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='mt-3'>
                                        <Col lg={3} md={3} sm={12}>
                                            <Form.Group as={Col} controlId="formSearch">
                                                <Form.Control type="text" placeholder="Search..." name='search' onChange={(e) => this.searchFilter(e)} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {
                                        this.state.getLeadsData.length > 0 ? (
                                            <Row>
                                                <Col sm={12}>
                                                    <div className="leads_table">
                                                        <Table striped bordered hover className="text-center leads_table">
                                                            <thead className='table-header'>
                                                                <tr>
                                                                    <th><input type="checkbox" className="custom-checkbox1" checked={this.state.selectAll}
                                                                        onChange={this.handleSelectAllChange} /> Select All</th>
                                                                    <th>Name</th>
                                                                    <th>mobile</th>
                                                                    <th>Father Name</th>
                                                                    <th>Father Mobile</th>
                                                                    {this.state.selectedOptionId == "2" && <th>Assigned To</th>
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    pagewiseFilterData.map((item) => {

                                                                        return (
                                                                            <>
                                                                                <tr key={item.id}>
                                                                                    <td>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={item.selected || false}
                                                                                            onChange={() => this.handleCheckboxChange(item)}
                                                                                        />
                                                                                    </td>
                                                                                    <td>{item.lead_name}</td>
                                                                                    <td>{item.lead_mobile}</td>
                                                                                    <td>{item.father_name}</td>
                                                                                    <td>{item.father_contact_no}</td>
                                                                                    {this.state.selectedOptionId == "2" && <td>{item.employee_name}</td>}
                                                                                </tr>
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                    <Row>
                                                        <Col className="d-flex justify-content-end mr-3 mb-3">
                                                            {
                                                                Array.from({ length: pages }, (_, index) => {
                                                                    return (
                                                                        <p className={this.state.currentPageStartCount / 10 == index ? "ml-2 pageIndex active" : "ml-1 pageIndex"} onClick={() => this.pageChange(index + 1)}>{index + 1}</p>
                                                                    )
                                                                })
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        ) : (
                                            <Col sm={12}>
                                                {
                                                    this.state.noDateError != "" ?
                                                        (
                                                            <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                                                        ) : ("")
                                                }
                                            </Col>
                                        )
                                    }
                                </>
                            ) : (
                                <Row>
                                    <Col>
                                        {
                                            this.state.loading == 1 ? (
                                                <Row className="my-2">
                                                    <Col>
                                                        <div className="spinner-border text-primary text-center loading-img-center"></div>
                                                    </Col>
                                                </Row>
                                            ) : (
                                                <Col sm={12}>
                                                    {
                                                        this.state.noDateError != "" ?
                                                            (
                                                                <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                                                            ) : ("")
                                                    }
                                                </Col>
                                            )
                                        }
                                    </Col>
                                </Row>
                            )
                    }
                </Modal.Body>

                {
                    this.state.getLeadsData.length > 0 ? (

                        <Modal.Footer variant="white" >
                            <Row>
                                <Col sm={12}>
                                    {this.state.currentStep == 5 ? (
                                        <Form.Text className={`form-text mb-2 ${this.state.submitMessageColor}`} style={{ textAlign: "center" }}>
                                            {this.state.currentStep == 5 && this.state.submitMessage}
                                        </Form.Text>
                                    ) : (
                                        <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                            {this.state.submitError}
                                        </Form.Text>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12} style={{ display: "block", textAlign: "center" }}>
                                    <div className="filter-block d-flex align-items-center justify-content-end mr-4 mt-3">
                                        {
                                            this.state.selectedOptionId == "2" ? (
                                                <Form.Check
                                                    type="checkbox"
                                                    id="deleteCheckbox"
                                                    label="Delete"
                                                    checked={this.state.deleteCheckboxChecked}
                                                    onChange={this.handleDeleteCheckboxChange}
                                                    style={{ width: "135px", transform: "scale(1.5)", fontWeight: "bold" }}
                                                />
                                            ) : ("")
                                        }

                                        {
                                            !this.state.deleteCheckboxChecked ? (
                                                <>
                                                    <Form.Control as="select" name="assigned" style={{ width: "185px" }} className="mr-3" onChange={this.assignedToHandle} value={this.state.assignedTo}>
                                                        <option value="">--Select Assigned To--</option>
                                                        {this.state.employeesData.map(item => (
                                                            <option value={item.employee_id}>{item.employee_name}</option>
                                                        ))}
                                                    </Form.Control>
                                                    <Form.Text className="form-text text-danger mr-3">
                                                        {this.state.assignedToError}
                                                    </Form.Text>
                                                </>
                                            ) : ("")
                                        }
                                        <Button variant="success" className="px-4 mb_50" onClick={this.handleSubmit}>
                                            {
                                                this.state.loadingSpinner == 1 ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : ""
                                            }
                                            Submit</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Modal.Footer>

                    ) : ("")
                }
            </Modal>
        )
    }
}


export default withRouter(withApollo(compose(
    graphql(ADD_OR_DELETE_LEADS, {
        name: "addOrDeleteLeads"
    }),
)(LeadAssign)));